import React, { Component } from "react";

export default class NotFound extends Component {
    render() {
        return (
            <div>
                <h1>
                    Page not found
                </h1>
                <p>
                    Please use the menu to the left, or go back to the hompage.
                </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/404.js